import { defineMessages } from 'react-intl'

export default defineMessages({
  modalTitle: {
    id: 'containers.UserSettingsPage.components.Notifications.WhatsAppPhoneModal.modalTitle',
    defaultMessage: 'WhatsApp Phone Number',
  },
  modalDescription: {
    id: 'containers.UserSettingsPage.components.Notifications.WhatsAppPhoneModal.modalDescription',
    defaultMessage: 'Please enter your WhatsApp phone number to receive notifications. This number must be registered with WhatsApp.',
  },
  phoneNumberLabel: {
    id: 'containers.UserSettingsPage.components.Notifications.WhatsAppPhoneModal.phoneNumberLabel',
    defaultMessage: 'Phone Number',
  },
  phoneNumberPlaceholder: {
    id: 'containers.UserSettingsPage.components.Notifications.WhatsAppPhoneModal.phoneNumberPlaceholder',
    defaultMessage: 'Enter phone number',
  },
  phoneNumberSearchPlaceholder: {
    id: 'containers.UserSettingsPage.components.Notifications.WhatsAppPhoneModal.phoneNumberSearchPlaceholder',
    defaultMessage: 'Search country',
  },
  phoneNumberNotFoundPlaceholder: {
    id: 'containers.UserSettingsPage.components.Notifications.WhatsAppPhoneModal.phoneNumberNotFoundPlaceholder',
    defaultMessage: 'No results found',
  },
  phoneNumberHint: {
    id: 'containers.UserSettingsPage.components.Notifications.WhatsAppPhoneModal.phoneNumberHint',
    defaultMessage: 'Include country code (e.g., +45 12345678)',
  },
  invalidPhoneError: {
    id: 'containers.UserSettingsPage.components.Notifications.WhatsAppPhoneModal.invalidPhoneError',
    defaultMessage: 'Please enter a valid phone number with country code',
  },
  save: {
    id: 'containers.UserSettingsPage.components.Notifications.WhatsAppPhoneModal.save',
    defaultMessage: 'Save',
  },
  saving: {
    id: 'containers.UserSettingsPage.components.Notifications.WhatsAppPhoneModal.saving',
    defaultMessage: 'Saving...',
  },
  cancel: {
    id: 'containers.UserSettingsPage.components.Notifications.WhatsAppPhoneModal.cancel',
    defaultMessage: 'Cancel',
  },
  saveSuccess: {
    id: 'containers.UserSettingsPage.components.Notifications.WhatsAppPhoneModal.saveSuccess',
    defaultMessage: 'WhatsApp phone number saved successfully',
  },
  saveError: {
    id: 'containers.UserSettingsPage.components.Notifications.WhatsAppPhoneModal.saveError',
    defaultMessage: 'Failed to save WhatsApp phone number',
  },
  privacyPolicyLabel: {
    id: 'containers.UserSettingsPage.components.Notifications.WhatsAppPhoneModal.privacyPolicyLabel',
    defaultMessage: 'I agree to the {privacyPolicy} and {terms}',
  },
  privacyPolicy: {
    id: 'containers.UserSettingsPage.components.Notifications.WhatsAppPhoneModal.privacyPolicy',
    defaultMessage: 'Privacy Policy',
  },
  termsAndConditions: {
    id: 'containers.UserSettingsPage.components.Notifications.WhatsAppPhoneModal.termsAndConditions',
    defaultMessage: 'Terms and Conditions',
  },
  privacyPolicyRequired: {
    id: 'containers.UserSettingsPage.components.Notifications.WhatsAppPhoneModal.privacyPolicyRequired',
    defaultMessage: 'You must agree to the Privacy Policy and Terms and Conditions to continue',
  },
})
